import { useCreateMacroData } from '../CreateMacroDataProvider'
import CreateFormConfig from './CreateFormConfig'
import DateRangeConfig from './DateRangeConfig'
import QueryConfig from './QueryConfig'
import RadioOptionsConfig from './RadioOptionsConfig'
import RelationConfig from './RelationConfig'
import SwitchLabelConfig from './SwitchLabelConfig'
import { componentTypes, specialFields } from '../constants'

FormLikeField = ({ label, children }) ->
  <div style={{ marginBottom: 24 }}>
    <span style={{ marginBottom: 5, display: 'block' }}>{ label }</span>
    { children }
  </div>

renderSpecialField = (key) -> (type, i) ->
  switch type
    when specialFields.QUERY
      <FormLikeField label="Query to get the options" key="#{key}-query-config-#{i}">
        <QueryConfig fieldKey={key} />
      </FormLikeField>
    when specialFields.RELATION
      <RelationConfig fieldKey={key} key="#{key}-relation-config-#{i}" />
    when specialFields.CREATE_FORM
      <CreateFormConfig fieldKey={key} key="#{key}-create-form-config-#{i}" />
    when specialFields.SWITCH_LABEL
      <SwitchLabelConfig fieldKey={key} key="#{key}-switch-label-config-#{i}" />
    when specialFields.DATE_RANGE
      <DateRangeConfig fieldKey={key} key="#{key}-date-range-config-#{i}" />
    when specialFields.RADIO_OPTIONS
      <RadioOptionsConfig fieldKey={key} key="#{key}-radio-options-config-#{i}" />
    else
      <div key="#{key}-undefined-config-#{i}"/>

TypeSpecificFields = ({ fieldKey }) ->

  [{ fieldData }] = useCreateMacroData()

  return null unless fieldData[fieldKey]

  (switch fieldData[fieldKey].type
    when componentTypes.default.select
      [specialFields.QUERY, specialFields.RELATION]
    when componentTypes.default.selectOrCreate
      [specialFields.QUERY, specialFields.RELATION, specialFields.CREATE_FORM]
    when componentTypes.default.switch
      [specialFields.SWITCH_LABEL]
    when componentTypes.default.dateRange
      [specialFields.DATE_RANGE]
    when componentTypes.default.dateTime
      [specialFields.DATE_TIME]
    when componentTypes.default.radio
      [specialFields.RADIO_OPTIONS]
    else []
  ).filter((el) -> el?
  ).map(renderSpecialField(fieldKey))

export default TypeSpecificFields
